import React, { useState } from 'react';
import RMSelect from 'components/customComponents/Controls/RMSelect';
import { SelectType } from 'business/models/CustomModels';
import { ScreenInfoDTO } from 'business/models/Models';

type SelectScreenOptionsProps = {
  options: SelectType[];
  defaultValue: number;
  screen: ScreenInfoDTO;
};

function SelectScreenOptions({
  options,
  defaultValue,
  screen,
}: SelectScreenOptionsProps) {
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  function onChange(e) {
    const numVal = e.target.value;
    setSelectedValue(numVal);
    screen.screenLotId = numVal;
  }

  return (
    <RMSelect
      options={options}
      style={{
        width: '100%',
        height: '2.125rem',
        minHeight: '2.125rem',
        maxHeight: '2.125rem',
        boxSizing: 'border-box',
        color: '#000000',
        border: '1px solid #000000',
        float: 'right',
        padding: '0px',
      }}
      selectedValue={selectedValue}
      onChange={onChange}
      placeholder={selectedValue.toString()}
    />
  );
}

export default SelectScreenOptions;
